import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { TechnicianService } from '../../../../services/technician.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-users-v2',
  templateUrl: './users-v2.component.html',
  styleUrls: ['./users-v2.component.scss'],
  providers: [MessageService],
})
export class UsersV2Component implements OnInit {
  public partnerID: string;
  public loading: boolean = false;
  public users: any = [];
  public tab = 0;
  public hasResources = false;
  public isWorkshop = true;
  public isRentals = false;

  constructor(
    public partnerService: PartnerService,
    public technicianService: TechnicianService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    public messageService: MessageService,
    public userService: UserService,
    private router: Router,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/user-management'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }
    this.getUsers();
  }

  getUsers() {
    this.loading = true;
    this.partnerService.getPartnerSystemUsers(this.partnerID).subscribe(
      (users) => {
        if (users) {
          this.users = users.sort((a, b) => {
            if (a.Name < b.Name) {
              return -1;
            } else if (a.Name > b.Name) {
              return 1;
            } else {
              return 0;
            }
          });
        }

        this.hasResources =
          this.users.filter((x) => {
            return (
              x.TechnicianID > 0 &&
              x.UserRoles.filter((y) => {
                return (
                  y.PartnerID === this.helpersService.getPartnerId() &&
                  (y.RoleID === 1 || y.RoleID === 4)
                );
              }).length > 0
            );
          }).length > 0;

        this.loading = false;
      },
      (err) => {
        this.loading = false;
      },
    );
  }

  changeTab(i) {
    this.tab = i;
  }
}
